const request = {
    invalid_input: 'Entrada inválida. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    range_not_satisfiable: 'Intervalo não satisfatório.',
};
export default Object.freeze(request);
